<script setup lang="ts">
const emit = defineEmits<{ saved: [] }>();

const isVisible = defineModel<boolean>('modelValue', { default: false });
const isManualModalOpen = ref(false);

// Bug real: sem lock nenhum, dava pra rolar o conteúdo atrás deste modal no
// mobile (ver useModalScrollLock).
useModalScrollLock(isVisible);

const { openDepositModal } = usePayments();

function onPixClick() {
  isVisible.value = false;
  openDepositModal();
}

function onManualClick() {
  isVisible.value = false;
  isManualModalOpen.value = true;
}
</script>

<template>
  <BaseModal
    v-model="isVisible"
    :aria-label="$t('bank_account.choice_modal.title')"
    :custom-class-wrapper="$style.wrapper"
    hide-close-button
    :mobile-fullscreen="false"
    :width="366"
  >
    <div :class="$style.content">
      <button
        :aria-label="$t('bank_account.choice_modal.close')"
        :class="$style.btnCloseIcon"
        type="button"
        @click="isVisible = false"
      >
        <svg
          aria-hidden="true"
          fill="none"
          height="14"
          viewBox="0 0 16 16"
          width="14"
        >
          <path
            d="M3 3l10 10M13 3L3 13"
            stroke="rgba(253,255,255,0.7)"
            stroke-linecap="round"
            stroke-width="2"
          />
        </svg>
      </button>

      <h2 :class="$style.title">
        {{ $t('bank_account.choice_modal.title') }}
      </h2>
      <p :class="$style.desc">
        {{ $t('bank_account.choice_modal.description') }}
      </p>

      <button
        :class="$style.btnPix"
        type="button"
        @click="onPixClick"
      >
        <svg
          aria-hidden="true"
          class="fill-white"
          height="14"
          viewBox="0 0 16 16"
          width="14"
        >
          <path
            d="M8 1.2L3.1 6.1a2.7 2.7 0 000 3.8L8 14.8l4.9-4.9a2.7 2.7 0 000-3.8L8 1.2zm0 2.3l3.3 3.3c.6.6.6 1.7 0 2.3L8 12.5 4.7 9.2a1.65 1.65 0 010-2.3L8 3.5z"
          />
        </svg>
        {{ $t('bank_account.choice_modal.cta_pix') }}
      </button>
      <p :class="$style.note">
        {{ $t('bank_account.choice_modal.cta_pix_note') }}
      </p>

      <button
        :class="$style.btnManual"
        type="button"
        @click="onManualClick"
      >
        {{ $t('bank_account.choice_modal.cta_manual') }}
      </button>
    </div>
  </BaseModal>

  <BankManualAccountModal
    v-model="isManualModalOpen"
    @saved="emit('saved')"
  />
</template>

<style module lang="postcss">
.wrapper {
  @apply !bg-bg-secondary !rounded-2xl !border !border-solid !border-primary/25;
}

.content {
  @apply relative flex flex-col pt-5 px-4 pb-6;
}

.btnCloseIcon {
  @apply absolute top-2 right-2 w-11 h-11 rounded-lg bg-transparent flex items-center justify-center;
}

.title {
  @apply mt-1 text-lg font-bold text-texts;
}

.desc {
  @apply mt-2 text-[13px] leading-[1.55] text-texts/70;
}

.btnPix {
  @apply flex items-center justify-center gap-2 w-full h-12 mt-5 rounded-[10px];
  @apply text-sm font-bold text-white tracking-[0.4px];
  background: radial-gradient(
    168.3% 138% at 36.76% -16.67%,
    #ff704a 0%,
    #ff3400 100%
  );
}

.note {
  @apply mt-2 text-[11px] text-texts/[0.55] text-center;
}

.btnManual {
  @apply w-full h-12 mt-3 rounded-[10px] border border-solid border-primary/40 bg-transparent;
  @apply text-[13px] font-semibold text-primary;
}
</style>
